import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ClipboardList, Wallet, MoreHorizontal, LogOut, Tag, Megaphone, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../lib/api";
import AnnouncementPopup from "../components/AnnouncementPopup";
import { useT } from "../lib/i18n";
import LangSwitch from "../components/LangSwitch";
import PwaBar from "../components/PwaBar";

const tabs = [
  { to: "/tech", icon: ClipboardList, label: "Görevler", end: true, testid: "tab-jobs" },
  { to: "/tech/chat", icon: MessageCircle, label: "Sohbet", testid: "tab-chat", badge: true },
  { to: "/tech/quotes", icon: Tag, label: "Teklif", testid: "tab-quotes" },
  { to: "/tech/announcements", icon: Megaphone, label: "Duyuru", testid: "tab-announcements" },
  { to: "/tech/balance", icon: Wallet, label: "Bakiyem", testid: "tab-balance" },
  { to: "/tech/more", icon: MoreHorizontal, label: "Daha", testid: "tab-more" },
];

export default function TechLayout() {
  const t = useT();
  const { user, logout } = useAuth();
  const [unread, setUnread] = useState(0);
  useEffect(() => { const t = () => api.get("/chat/unread").then((r) => setUnread(r.data.unread)).catch(() => {}); t(); const i = setInterval(t, 30000); return () => clearInterval(i); }, []);
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200/80 px-4 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src="/brand/logo.png" alt="ServisPlus" className="h-9 w-auto object-contain" />
          <div>
            <div className="text-sm font-display font-bold text-slate-900 leading-none">ServisPlus</div>
            <div className="text-[10px] text-slate-500 mt-0.5">{t("Usta Paneli")}</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right">
            <div className="text-xs font-semibold text-slate-900 leading-none">{user?.name}</div>
            <div className="text-[10px] text-slate-500 mt-0.5">{user?.email}</div>
          </div>
          <button onClick={logout} className="p-2 -mr-1 text-slate-600 hover:text-rose-600" data-testid="tech-logout">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>

      <main className="flex-1 pb-24 max-w-2xl w-full mx-auto px-4 py-4">
        <div className="flex justify-end mb-2"><LangSwitch /></div>
        <PwaBar />
        <Outlet />
        <AnnouncementPopup />
      </main>

      <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200">
        <div className="max-w-2xl mx-auto grid grid-cols-6">
          {tabs.map((tb) => (
            <NavLink
              key={tb.to}
              to={tb.to}
              end={tb.end}
              data-testid={tb.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 text-[11px] font-medium ${
                  isActive ? "text-blue-700" : "text-slate-500"
                }`
              }
            >
              <span className="relative"><tb.icon className="h-5 w-5" />{tb.badge && unread > 0 && <span className="absolute -top-1.5 -right-2 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[14px] h-[14px] px-1 flex items-center justify-center" data-testid="chat-badge">{unread}</span>}</span>
              {t(tb.label)}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
